





























































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import { AxiosResponse } from "axios";
import UserService from "@/services/user.service";
import User from '@/models/security/user.model';

import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import BaseApi from '@/core/HttpResources/BaseApi';
@Component({
  components: {
    UserBasicInformationComponent
  }
})
export default class BaseSelectPerson extends Vue {
  @Prop() public label!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public placeholder!: string;
  @Prop() public disabled!: boolean;
  @Prop({ default: true }) public multiple!: boolean;
  @Prop() public value: any;
  @Prop() public initOnDisable!: boolean;
  @Prop() public hideSelected!: boolean;
  @Prop() public profilePictureCustomClassProp!: string;
  @Prop() public informationCustomClassProp!: string;
  @Prop() public profilePictureCustomPaddingProp!: string;
  @Prop() public informationCustomPaddingProp!: string;
  @Prop() public isInvestigator: boolean;
  @Prop() public isAllUser: boolean;
  @Prop() public excludeId!: number;
  @Prop() public loadOnMount!: boolean;
  @Prop() public loadWhen!: boolean;
  @Prop() public nameValueCode!: string;
  @Prop() public options!: Array<any>;
  @Prop() public dependencyKey!: string;
  @Prop() public dependecyValue!: string;
  @Prop() public openDirection!: string;
  @Prop() public size!: string;

  @Prop() public isQueryString!: boolean;
  @Prop() public allowEmpty!: boolean;
  @Prop() public searchPersonById!: boolean;

  userService: UserService = new UserService();
  selected: any = null;
  data: any = [];
  loading: boolean = false;
  nombre: any = null;
  sLoadOnMount = this.loadOnMount === false ? false : true;
  timerFunction: any;

  profilePictureCustomClass;
  informationCustomClass;
  profilePictureCustomPadding;
  informationCustomPadding;

  mounted() {
    if(this.isInvestigator) {
      this.getInvestigator();
    }
    this.profilePictureCustomClass = this.profilePictureCustomClassProp ? this.profilePictureCustomClassProp : 'column is-2';
    this.informationCustomClass = this.informationCustomClassProp ? this.informationCustomClassProp : 'column is-10';
    this.profilePictureCustomPadding = this.profilePictureCustomPaddingProp ? this.profilePictureCustomPaddingProp : 'padding-top: 0px; padding-right: 0;';
    this.informationCustomPadding = this.informationCustomPaddingProp ? this.informationCustomPaddingProp : 'padding-top: 0px; padding-left: 0;';
  }

  get sAction() {
    return this.action ? "/" + this.action : "";
  }

  customLabel ({ id, fullName, email, profileImage, identification }: any) {
    let label = this.getProfileImage(profileImage) + `- ${fullName}`;
    return  label;
  }

  
  onSelected(selected: BaseModel) {
    this.$emit("input", selected.id);
    this.$emit("select", selected);
    this.$emit("onChange", selected);
  }
  
  
   getProfileImage(profileImage: any) {
    if (profileImage && profileImage)
      return `data:image/jpg;base64, ${profileImage}`;
    return false;
  }

  getPerson(value?: any) {
    this.loading = true;
    if (this.timerFunction) {
      clearTimeout(this.timerFunction);
    }
    if (this.nombre) {
      this.timerFunction = setTimeout(() => {
        this.userService.getUserByCriteria(this.nombre).then(persons => {
        if (persons) {
          if (this.data && this.data.length > 0) {
            persons.forEach((person: User) => {
              if (!this.data.some((x: User) => x.id == person.id)) {
                this.data.unshift(person);
              }
            });
          } else {
            this.data = persons;
            this.loading = false;
          }
          this.loading = false;
        }
      });
      }, 500);
    }
  }

  searchChange(text: string) {
    this.nombre = text;
    this.$emit("searchChange", text);
  }

  @Watch("selected")
  onSelectChange() {
    if (this.selected) {
      this.$emit("input", this.selected.id);
      this.$emit("selected", this.selected);
    } else {
      this.$emit("input", null);
      this.$emit("selected", null);
    }
  }

  getInvestigator() {
    this.userService.getInvestigator().then(response =>{
      this.data = response;
        if(this.value && !isNaN(this.value)) {
          this.selected = this.data.find(x => x.id == this.value);
        }
    })
    return this.data;
  }

  @Watch("value", { immediate: true })
  onValueChange(value: any) {
    if(value) {
      if (this.searchPersonById && !isNaN(this.value)) {
        this.userService.getUserById(value).then(response => {
          this.selected = response;
        });
      }
      if(this.isInvestigator) {
        this.getInvestigator();
      }
      if (this.data.length && !isNaN(this.value)) {
        var person = this.data.find(item => item.id == value);
        this.selected = person ? person : null;
      }
    }
    if (value === null) {
      this.selected = value;
    }
  }

  @Watch("nombre")
  onNombreChange(value?: string) {
    if (value) {
      this.getPerson(value);
    }
  }
 
  /*
  async getAll(value?: any) {
    if (!this.options) {
      this.loading = true;
      
      let url = `${this.controller}${this.sAction}`;

      if (this.nameValueCode)
        url = "NameValues/" + this.nameValueCode + "/children";

      let baseApi = new BaseApi(url);
      if (this.excludeId) {
        baseApi.apiUrl += `?$filter=id ne ${this.excludeId}`;
      }
      if (this.dependecyValue) {
        if (!this.isQueryString) {
          if (isNaN(this.dependecyValue as any))
            baseApi.apiUrl += `?$filter=${this.dependencyKey} eq '${this.dependecyValue}'`;
          else
            baseApi.apiUrl += `?$filter=${this.dependencyKey} eq ${this.dependecyValue}`;
        } else {
          if (isNaN(this.dependecyValue as any))
            baseApi.apiUrl += `?${this.dependencyKey}='${this.dependecyValue}'`;
          else
            baseApi.apiUrl += `?${this.dependencyKey}=${this.dependecyValue}`;
        }
      }

      await baseApi.request(
        "get",
        String(),
        null,
        {},
        (response: AxiosResponse) => {
          let data = response.data as BaseModel[];
          this.data = data;
          this.processData(response, value);
          this.$emit("load-finally", data);

        },
        (response: AxiosResponse) => {
          console.log(response);
          this.loading = false;

          this.$emit("load-error", response);
        },
        (response: AxiosResponse) => {
        }
      );
    } else {
      this.data = this.options;
      this.processData(null, value);
    }
  }
  processData(response?: any, value?: any) {
    if (this.options && !this.options.length) {
      return;
    }
    this.loading = false;

    this.data.forEach(x => {
      if (x.isDefault) {
        this.selected = x;
        this.$emit("input", this.selected.id);
        this.$emit("select", this.selected);
      }
    });

    if (value) {
      var filter = this.data.filter(item => item.id == value);
      this.selected = filter.length > 0 ? filter[0] : new BaseModel();
      this.$emit("input", this.selected.id);
      this.$emit("select", this.selected);
    }
    this.$emit("onLoad", this.data);
    this.$emit("load-success", response, this.data);
  }
  */
}
